export function getDefaultOptions() {
    return {
        buttonsSelector: `.btn-filter-tab`,
    };
}

export function initialize(_options = getDefaultOptions()) {
    const options = _options;

    console.log("Initializing buttons scroll tab.");

    document.querySelectorAll(options.buttonsSelector).forEach(btnList => {
        let isDown = false;
        let startX;
        let scrollLeft;

        btnList.addEventListener('mousedown', (e) => {
            isDown = true;
            btnList.classList.add('active');
            startX = e.pageX - btnList.offsetLeft;
            scrollLeft = btnList.scrollLeft;
        });

        btnList.addEventListener('mouseleave', () => {
            isDown = false;
            btnList.classList.remove('active');
        });

        btnList.addEventListener('mouseup', () => {
            isDown = false;
            btnList.classList.remove('active');
        });

        btnList.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - btnList.offsetLeft;
            const walk = (x - startX) * 2; // Velocità di scroll
            btnList.scrollLeft = scrollLeft - walk;
        });

        // Supporto touch per dispositivi mobili
        btnList.addEventListener('touchstart', (e) => {
            isDown = true;
            startX = e.touches[0].pageX - btnList.offsetLeft;
            scrollLeft = btnList.scrollLeft;
        });

        btnList.addEventListener('touchend', () => {
            isDown = false;
        });

        btnList.addEventListener('touchmove', (e) => {
            if (!isDown) return;
            const x = e.touches[0].pageX - btnList.offsetLeft;
            const walk = (x - startX) * 2;
            btnList.scrollLeft = scrollLeft - walk;
        });

    });

    console.log("Button scroll tab initialized.");
}